import React from 'react';
import styled from 'styled-components';
import { SvgWrapper } from '../svg-wrapper';
var Svg = /*#__PURE__*/styled(SvgWrapper).withConfig({
  displayName: "arrow-up-icon__Svg",
  componentId: "zptqqr-0"
})(["width:16px;height:10px;color:", ";"], p => p.theme.colors.primary500);
export var ArrowUp = (_ref) => {
  var {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(Svg, {
    viewBox: "0 0 16 10",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -6.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    // eslint-disable-next-line max-len
    d: "M12,8.69479221 L5.848171,14.8466212 C5.49669914,15.1980931 4.92685066,15.1980931 4.5753788,14.8466212 C4.22390693,14.4951493 4.22390693,13.9253009 4.5753788,13.573829 L11.3636039,6.7856039 C11.7150758,6.43413203 12.2849242,6.43413203 12.6363961,6.7856039 L19.4246212,13.573829 C19.7760931,13.9253009 19.7760931,14.4951493 19.4246212,14.8466212 C19.0731493,15.1980931 18.5033009,15.1980931 18.151829,14.8466212 L12,8.69479221 Z"
  })))));
};